var _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_67",
    "data-name": "Group 67",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.536,
    height: 28.536,
    viewBox: "0 0 28.536 28.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    fill: "none",
    stroke: "#00a94d",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.268,
    cy: 14.268,
    r: 14.268,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.268,
    cy: 14.268,
    r: 13.268,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "i_",
    "data-name": "i ",
    transform: "translate(6 1.536)",
    fill: "#00a94d",
    fontSize: 20,
    fontFamily: "TimesNewRomanPS-ItalicMT, Times New Roman",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.222,
    y: 18
  }, "i"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.0c6d1e1172ed5de6ca0e951254f335d7.svg";
export { ForwardRef as ReactComponent };